import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.CONTROLS,
  nodeType: Generator.NODETYPE.PUT
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/put.js